let module = angular.module('app.resources');

module.factory('Ticket', function Ticket($resource, $q) {
  'ngInject';

  var resource = $resource(
    `${API_ROOT}/account/:resource/:id/tickets`,
    { id: '@id', resource: '@resource' },
    {
      summary: {
        method: 'GET',
        url: `${API_ROOT}/account/:resource/:id/tickets/summary`,
      },
    }
  );

  resource.queryAll = function (params) {
    let tickets = [];
    let d = $q.defer();
    let paramsCopy = angular.copy(params);
    resource.query(
      paramsCopy,
      (results, headers) => {
        tickets = tickets.concat(results);
        let pagination = JSON.parse(headers('x-pagination'));
        if (!pagination || !pagination.last) {
          d.resolve(tickets);
          return;
        }
        var promises = [];
        for (var p = 1; p <= pagination.last; p++) {
          let paramsCopy2 = angular.copy(params);
          paramsCopy2.p = p;
          promises.push(resource.query(paramsCopy2).$promise);
        }
        $q.all(promises)
          .then((results) => {
            let i;
            for (i = 0; i < results.length; i++) {
              tickets = tickets.concat(results[i]);
            }
            d.resolve(tickets);
          })
          .catch((e) => d.reject(e));
      },
      (err) => {
        d.reject(err);
      }
    );
    return d.promise;
  };

  return resource;
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/ticket.js